<template>
  <div id="app">
    <Header
      title="Tractable 
      Probabilistic 
      Description Logic"
      subtitle="Algorithms and implementation"
      author="Andrew Ijano Lopes"
      supervisor="Marcelo Finger"
    />

    <div class="super-section column super-section-logo">
      <img class="pgel-logo" :src="`${publicPath}header-background.svg`" />
    </div>

    <div class="super-section column">
      <Section
        content="<b>Description logics</b> are a family of formal knowledge representation
      languages."
      />
    </div>

    <div class="super-section">
      <Section
        content="One of them, the <b>EL++</b>, is an expressive logic whose decision
      procedure is tractable. it shines when you want to work with a large
      amount of data, helping the <b>healthcare</b> worldwide."
      />
      <HealthcareLogo />
    </div>

    <div class="super-section column">
      <Section
        content="However, simply adding probabilistic constraints leaves its decision
      complexity <b>untractable</b>."
      />
      <ProbabilityLogo />
    </div>

    <div class="super-section">
      <Section
        content="In this project, we study a reasonably expressive fragment of it, called graphic EL++, and its probabilistic extension, <b>PGEL++</b>.<br><br>

        This fragment alows us to express the axioms as a <b>graph</b>,  which inherits tractable decision procedure."
      />
    </div>

    <div class="super-section">
      <Section
        content="Then, this project aims to develop and implement algorithms for a
      <b>tractable decision of PGEL++</b>. <br><br>
      
      We're going to build graph-based machinery
      to obtain a tractable maxSAT problem for GEL++ and a column generation
      procedure for deciding PGEL++, which uses the maxSAT solver as an
      auxiliary procedure."
      />
    </div>

    <div class="super-section column full-height">
      <a href="https://github.com/AndrewIjano/pgel-sat">
        <Section
          content="Check the <b>github</b> repository for the implementation."
        />
        <img class="logo" :src="`${publicPath}github-logo.svg`" />
      </a>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Section from './components/Section.vue';
import HealthcareLogo from './components/HealthcareLogo.vue';

import ProbabilityLogo from './components/ProbabilityLogo.vue';
export default {
  name: 'App',
  components: {
    Header,
    Section,
    HealthcareLogo,
    ProbabilityLogo
  },
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;

}

#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  text-align: center;
  background-color: #f7fafcff;
  color: #2c353a;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

b {
  color: #fa6940;
}

.super-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  width: 100%;
  height: content;
  min-height: 60vh;

  .pgel-logo {
    display: none;
  }
}

.super-section-logo {
  display: none;
}

.full-height {
  min-height: 100vh;
}

.column {
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 12em;
}

a {
  text-decoration: none;
  cursor: pointer;
  color: inherit;
}

@media (max-width: 1080px) {
  .super-section-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .super-section .pgel-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    max-width: 20em;
  }
}
@media only screen and (max-width: 500px) {
  .super-section {
    flex-direction: column;
  }
}
</style>
